<template>
    <div style="height: 100%; width: 100%;">
        <div class="header">
            <div class="title-container">
                <h3>Agenda</h3>
            </div>
        </div>
        <div class="cards-container">
            

        </div>

    </div>
</template>
<script>
import FullCalendar from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
export default{
    components:{
        FullCalendar
    },
    computed:{
        calendarOptions() {
            return {
                locale: 'fr',
                firstDay: 1,
                weekday: 'long',
                plugins: [dayGridPlugin, interactionPlugin],
                initialView: 'dayGridWeek',
                events: this.formatedEventsList,
                headerToolbar: {
                    left: 'prev,next',
                    center: 'title',
                    right: 'dayGridMonth,dayGridWeek,dayGridDay'
                },
                eventTimeFormat: {
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false,
                },
                eventClick: this.defineSelectedEvent
            }
        },
    }
}
</script>
<style scoped>
.header {
    width: 100%;
    height: 60px;
    background-color: #333;
    display: flex;
    justify-content: start;
    align-items: center;
    border-bottom: 0.1px solid #bcbcbc;
}

.title-container {
    margin-left: 20px;
}

.title-container h3 {
    color: #fff;
}

.cards-container {
    height: calc(100%-60px);
    padding: 15px;
    background-color: #3f3f3f;
    display: flex;
    flex-direction: row;
    gap: 15px;
}
</style>